import { render, staticRenderFns } from "./ModalVeiculo.vue?vue&type=template&id=84483a4c"
import script from "./ModalVeiculo.vue?vue&type=script&lang=js"
export * from "./ModalVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports